import PropTypes from 'prop-types'

import { Centered, Loader, Margin } from '../../..'
import ContentMedia from '../Media'
import LayerSection from './LayerSection'
import { CloseButton, Header, PageTitle, ShadowColumn, Unselected } from './Content.style'
import { useSize } from '../../../utils'
import { useLocation, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'

const ContentMediaLayers = ({
    bulkSelection,
    channelName,
    hasPermissionToApproveLayers,
    isWorkingLayers,
    isWorkingMedia,
    onApproveLayer,
    onApproveMedia,
    onDropMedia,
    onOpenFormLayers,
    onOpenFormMedia,
    onRemoveLayers,
    onRemoveMedia,
    onDownloadMedia,
    onDownloadLayer,
    onTextChangeLayers,
    onTextChangeMedia,
    onChangeLayers,
    onChangeMedia,
    optionsLayers,
    optionsMedia,
    selectedPlaylist,
}) => {
    const { t } = useTranslation()
    const { isMobile } = useSize()
    const location = useLocation()
    const params = useParams()

    const isWorking = isWorkingLayers || isWorkingMedia

    const getLayers = () => {
        if (!selectedPlaylist) {
            return null
        }

        const { layers } = selectedPlaylist

        return layers
    }

    const getMedia = () => {
        if (!selectedPlaylist) {
            return null
        }

        const { media } = selectedPlaylist

        return media
    }

    const { name: playlistName } = selectedPlaylist || {}
    const layers = getLayers()
    const media = getMedia()
    const selectedLayer = layers && layers.length ? layers[0] : null

    /**
     * On approve layer button click
     * @param {Object} e event instance
     */
    const onApproveLayerClick = (e) => {
        if (typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }

        if (selectedLayer) {
            onApproveLayer(selectedLayer.id, true)
        }
    }

    const isPlaylistSelected = !!params.playlist
    const backUrl = location.pathname.split('/').slice(0,-1).join('/')

    return (
        // <Board isOpen isMobile={isMobile} onClose={() => onChangePlaylist()}></Board>
        <ShadowColumn
            isMobile={isMobile}
            isSelected={isPlaylistSelected}
            style={{
                width: isMobile ? '100%' : 'calc(100% - 800px)',
                zIndex: 15,
            }}
        >
            {!selectedPlaylist && !isWorking && <Unselected>{t('content-playlist-unselected')}</Unselected>}
            {!selectedPlaylist && isWorking && (
                <Unselected>
                    <Centered horizontal>
                        <Margin size="lg"><Loader /></Margin>
                    </Centered>
                </Unselected>
            )}
            {selectedPlaylist && (
                <>
                    <Header bottom left size="md" style={{ height: '116px' }}>
                        {isPlaylistSelected && isMobile && (
                            <CloseButton to={backUrl} replace>&lt;&nbsp;Back to Channels</CloseButton>
                        )}
                        <PageTitle>
                            {playlistName}
                            <span className="names-separator">&nbsp;&gt;&nbsp;</span>
                            {t('Layers')}
                        </PageTitle>
                    </Header>
                    <LayerSection
                        hasPermissionToApproveLayers={hasPermissionToApproveLayers}
                        isWorking={isWorkingLayers}
                        onApproveLayerClick={onApproveLayerClick}
                        onChangeLayers={onChangeLayers}
                        onDownloadLayer={onDownloadLayer}
                        onOpenFormLayers={onOpenFormLayers}
                        onRemoveLayers={onRemoveLayers}
                        onTextChangeLayers={onTextChangeLayers}
                        optionsLayers={optionsLayers}
                        selectedLayer={selectedLayer}
                    />
                    <ContentMedia
                        inSelectedPlaylist
                        isLoading={isWorkingMedia}
                        onApproveMedia={onApproveMedia}
                        onDropMedia={onDropMedia}
                        onOpenFormMedia={onOpenFormMedia}
                        onRemoveMedia={onRemoveMedia}
                        onDownloadMedia={onDownloadMedia}
                        onTextChangeMedia={onTextChangeMedia}
                        onChangeMedia={onChangeMedia}
                        optionsMedia={optionsMedia}
                        bulkSelection={bulkSelection}
                        data={media}
                        inPlaylist={selectedPlaylist}
                        t={t}
                    />
                </>
            )}
        </ShadowColumn>
    )
}

ContentMediaLayers.propTypes = {
    hasPermissionToApproveLayers: PropTypes.bool,
    isWorkingLayers: PropTypes.bool,
    isWorkingMedia: PropTypes.bool,
    onApproveLayer: PropTypes.func,
    onApproveMedia: PropTypes.func,
    onChangePlaylist: PropTypes.func,
    onDropMedia: PropTypes.func,
    onOpenFormLayers: PropTypes.func,
    onOpenFormMedia: PropTypes.func,
    onRemoveLayers: PropTypes.func,
    onRemoveMedia: PropTypes.func,
    onDownloadMedia: PropTypes.func,
    onDownloadLayer: PropTypes.func,
    onTextChangeLayers: PropTypes.func,
    onTextChangeMedia: PropTypes.func,
    onChangeLayers: PropTypes.func,
    onChangeMedia: PropTypes.func,
    optionsLayers: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            value: PropTypes.string,
        })
    ),
    optionsMedia: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            value: PropTypes.string,
        })
    ),
    selectedChannel: PropTypes.shape({}),
    selectedPlaylist: PropTypes.shape({}),
    bulkSelection: PropTypes.func,
}

ContentMediaLayers.defaultProps = {
    hasPermissionToApproveLayers: false,
    isWorkingLayers: false,
    isWorkingMedia: false,
    onApproveLayer: () => null,
    onApproveMedia: () => null,
    onChangePlaylist: () => null,
    onDropMedia: () => null,
    onOpenFormLayers: () => null,
    onOpenFormMedia: () => null,
    onRemoveLayers: () => null,
    onRemoveMedia: () => null,
    onDownloadMedia: () => null,
    onDownloadLayer: () => null,
    onTextChangeLayers: () => null,
    onTextChangeMedia: () => null,
    onChangeLayers: () => null,
    onChangeMedia: () => null,
    bulkSelection: () => null,
    optionsLayers: [],
    optionsMedia: [],
    selectedChannel: {},
    selectedPlaylist: {},
}

export default ContentMediaLayers
